'use client';

import React from 'react';
import { StyledAnalyzerCta } from './analyzerCta.styles';

export interface IAnalyzerCtaProps {
  /** Optional override for the heading copy. */
  heading?: string;
  /** Optional override for the supporting line. */
  subheading?: string;
}

/**
 * Website Analyzer call-to-action band for free-tool / resource pages.
 * A plain GET form pointing at /website-analyzer: the input's name="url" makes the
 * browser append ?url=<site>, which the analyzer reads and auto-runs. No JS required.
 */
export const AnalyzerCta = ({
  heading = 'See the full picture of your website',
  subheading = "You just checked one thing. Run a free, instant analysis and get specific fixes across SEO, conversion, trust, and engagement.",
}: IAnalyzerCtaProps) => {
  return (
    <StyledAnalyzerCta>
      <div className="analyzer-cta-inner">
        <h2>{heading}</h2>
        <p>{subheading}</p>
        <form
          className="analyzer-cta-form"
          action="https://www.commoninja.com/website-analyzer"
          method="get"
          target="_blank"
          rel="noopener"
        >
          <input
            className="analyzer-cta-input"
            type="url"
            name="url"
            required
            placeholder="yourwebsite.com"
            aria-label="Your website URL"
          />
          <button className="analyzer-cta-btn" type="submit">
            Analyze my site
          </button>
        </form>
      </div>
    </StyledAnalyzerCta>
  );
};
